// src/api/authApi.js
import axios from "axios";
import { attachAuthInterceptors } from "./attachInterceptors";
import { createApi } from './createApi';
export const initAuthApi = (logout) => createApi(process.env.REACT_APP_API_AUTH, logout);

const authApi = axios.create({
  baseURL: process.env.REACT_APP_API_AUTH,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptors(authApi);

export default authApi;
